// React
import { useReducer } from "react";
// MUI
import { Button, Stack } from "@mui/material";

// Components
import SimpleTextField from "@Layouts/components/InputComponents/SimpleTextField";

// Types
import { ButtonClasses } from "@mui/material/Button/buttonClasses";

type BasicAuthVariantProps = Readonly<{
	disabled: boolean;
	isError: boolean;
	error?: Error | null;
	buttonClasses?: Partial<ButtonClasses>;
	inputProps?: {
		classes: string;
	};
}>;

type State = {
	username: string;
	password: string;
};

type Action = { type: "SET_USERNAME"; payload: string } | { type: "SET_PASSWORD"; payload: string };

function reducer(state: State, action: Action) {
	switch (action.type) {
		case "SET_USERNAME":
			return { ...state, username: action.payload };
		case "SET_PASSWORD":
			return { ...state, password: action.payload };
		default:
			return state;
	}
}

export default function BasicAuthVariant(props: BasicAuthVariantProps) {
	const { isError, error, disabled, inputProps, buttonClasses } = props;

	const [state, dispatch] = useReducer(reducer, {
		username: "",
		password: "",
	});

	const { username, password } = state;

	return (
		<Stack spacing={2} mt={4}>
			<SimpleTextField
				text={username}
				placeholder="Username"
				editable
				outlined
				type="text"
				name="username"
				inputProps={inputProps}
				// Callbacks
				onChange={(value) => dispatch({ type: "SET_USERNAME", payload: value })}
			/>
			<SimpleTextField
				text={password}
				placeholder="Password"
				editable
				outlined
				type="password"
				name="password"
				inputProps={inputProps}
				autoComplete={"new-password"}
				// Callbacks
				onChange={(value) => dispatch({ type: "SET_PASSWORD", payload: value })}
			/>
			<Stack className="text-center" sx={{ display: isError ? "block" : "none" }}>
				<span className="alert-message">{error?.message}</span>
			</Stack>

			<Button
				variant="contained"
				type={"submit"}
				fullWidth
				disabled={disabled || !username || !password}
				// Styles
				classes={buttonClasses}
			>
				Log in
			</Button>
		</Stack>
	);
}
